import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconRestartOutline } from '@saucelabs/ds-icons';

import { MANUAL_TEST_EVENTS, trackEvent } from '../../../tracking';
import { restartMobileDeviceApp } from '../../../actions';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const RestartAppButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceDescriptor,
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);

  const restartApp = () => {
    void dispatch(restartMobileDeviceApp());

    trackEvent(MANUAL_TEST_EVENTS.RESTART_APP, {
      deviceName: deviceDescriptor.name,
      os: deviceDescriptor.os,
    });
  };

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconRestartOutline}
      label="Restart App"
      onPress={restartApp}
      role={role}
    />
  );
};

RestartAppButton.displayName = 'RestartAppButton';

export default RestartAppButton;
